var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhtspMsgOpenRate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.87,23.08c-.27,0-.51.11-.69.31l-3.67,4.24v-3.64c0-.5-.41-.91-.91-.91h-1.85c-.84,0-1.53-.69-1.53-1.53v-13.29c0-.84.69-1.53,1.53-1.53h22.51c.84,0,1.53.69,1.53,1.53v13.29c0,.84-.69,1.53-1.53,1.53h-15.39ZM31.61,21.55v-13.29c0-1.84-1.5-3.34-3.34-3.34H5.76c-1.84,0-3.34,1.5-3.34,3.34v13.29c0,1.84,1.5,3.34,3.34,3.34h.95v4.01c0,.74.6,1.34,1.35,1.34.38,0,.75-.17,1.01-.47l4.22-4.89h14.98c1.83,0,3.33-1.49,3.33-3.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.93,34.62c.26.3.63.47,1.01.47.16,0,.32-.03.47-.09.53-.2.87-.69.87-1.26v-4.01h.95c1.84,0,3.34-1.5,3.34-3.34v-13.29c0-1.84-1.5-3.34-3.34-3.34-.5,0-.91.41-.91.9s.41.91.91.91c.84,0,1.53.69,1.53,1.53v13.29c0,.84-.69,1.53-1.53,1.53h-1.86c-.5,0-.91.41-.91.91v3.64l-3.67-4.24c-.17-.2-.42-.31-.69-.31h-13.6c-.5,0-.91.41-.91.91s.41.91.91.91h13.19l4.23,4.87Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.96,
    cy: 14.92,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.01,
    cy: 14.92,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.06,
    cy: 14.92,
    r: 1.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhtspMsgOpenRate);
export default __webpack_public_path__ + "static/media/whtsp-msg-open-rate.a57928639907cdc5b563229c0cd06706.svg";
export { ForwardRef as ReactComponent };